import { render, staticRenderFns } from "./newGather.vue?vue&type=template&id=725552a9&"
import script from "./newGather.vue?vue&type=script&lang=js&"
export * from "./newGather.vue?vue&type=script&lang=js&"
import style0 from "./newGather.vue?vue&type=style&index=0&id=725552a9&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports